"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.browserFormat = exports.resetFormatStyle = exports.nodeFromat = exports.createFormat = void 0;
var utils_1 = require("../utils/utils");
var R_VALUE = /:([^;]+)/g;
function createFormat(styles, format) {
    return function (entry) {
        return format(entry, {
            base: styles.level[entry.level] || '',
            label: styles.label[entry.level] || '',
        });
    };
}
exports.createFormat = createFormat;
exports.nodeFromat = createFormat({
    level: {
        log: '\x1B[0m',
        info: '\x1B[34m',
        done: '\x1B[34m',
        warn: '\x1B[33m',
        error: '\x1B[31m',
        verbose: '\x1B[35m',
    },
    label: {
        log: '\x1B[4m',
        info: '\x1B[4m',
        done: '\x1B[4m',
        error: '\x1B[4m',
        warn: '\x1B[4m',
        verbose: '\x1B[4m',
    },
}, function (entry, style) {
    var values = [];
    if (entry.badge != null) {
        values.push(entry.badge);
    }
    if (entry.label != null) {
        values.push("".concat(style.base).concat(style.label).concat(entry.label, "\u001B[0m"));
    }
    if (entry.args != null) {
        values.push.apply(values, entry.args);
    }
    if (entry.meta !== null) {
        values.push("".concat(entry.meta.file, ":").concat(entry.meta.line, ":").concat(entry.meta.col));
    }
    values.push('\x1B[0m');
    return values;
});
var LABEL_STYLE = 'text-decoration: underline; font-weight: bold;';
function resetFormatStyle(val) {
    return val.replace(R_VALUE, ': inherit');
}
exports.resetFormatStyle = resetFormatStyle;
exports.browserFormat = createFormat({
    level: {
        log: 'color: #333;',
        info: 'color: dodgerblue;',
        done: 'color: #1aaa55;',
        warn: 'color: orange;',
        error: 'color: red;',
        verbose: 'color: magenta;',
    },
    label: {
        log: LABEL_STYLE,
        info: LABEL_STYLE,
        done: LABEL_STYLE,
        warn: LABEL_STYLE,
        error: LABEL_STYLE,
        verbose: LABEL_STYLE,
    },
}, function (entry, style) {
    var values = [];
    var valuesStyle = [];
    var args = entry.args;
    if (entry.ts > 0) {
        valuesStyle.push('%c[%s] ');
        values.push(style.base, (0, utils_1.timeFormat)(entry.ts));
    }
    if (entry.badge != null) {
        valuesStyle.push('%s');
        values.push(entry.badge);
    }
    if (entry.label != null) {
        valuesStyle.push('%c%s%c ');
        values.push(style.label + style.base, entry.label, resetFormatStyle(style.label));
    }
    if (args != null) {
        var n = args.length;
        if (n > 0) {
            valuesStyle.push('%c');
            values.push(style.base);
            for (var i = 0; i < n; i++) {
                var val = args[i];
                valuesStyle.push("".concat(typeof val === 'string' ? '%s' : '%o', " "));
                values.push(val);
            }
        }
    }
    if (entry.meta != null) {
        valuesStyle.push('%s');
        values.push("".concat(entry.meta.file, ":").concat(entry.meta.line, ":").concat(entry.meta.col));
    }
    values.unshift(valuesStyle.join(''));
    return values;
});
//# sourceMappingURL=format.js.map